import { Injectable } from '@angular/core';
import { Subject, from, BehaviorSubject, Observable } from 'rxjs';
import { ROLES } from '../roleList/priorityRoleList';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  data = {};
  events;
  listeners: any = {};
  menuExpand = new BehaviorSubject<any>(null);
  activelanguage = new BehaviorSubject<any>(null);
  private _CISubject = new BehaviorSubject<any>({});
  public useCase$: Observable<any> = this._CISubject.asObservable();

  private subject = new Subject<any>();
  constructor() {
    this.events = from(this.subject);
  }

  get currentUsecase() {
    return this._CISubject.getValue();
  }

  // Setter: updates the value
  set currentUsecase(usecase) {
    this._CISubject.next(usecase);
  }


  getData(key: string): any {
    return this.data[key];
  }

  setData(key: string, value: any): void {
    this.data[key] = value;
  }

  getMenuStatus() {
    return this.menuExpand;
  }

  setMenuStatus(status) {
    this.menuExpand.next(status);
  }

  clearData(): void {
    this.data = {};
  }

  getStorageData(key: string): any {
    return key === 'savedClusterList' ? localStorage.getItem(key) : sessionStorage.getItem(key);
  }

  setStorageData(key: string, value): void {
    key === 'savedClusterList' ? localStorage.setItem(key, value) : sessionStorage.setItem(key, value);
  }

  clearStorageData(): void {
    sessionStorage.clear();
  }

  removeItemFromStorage(key: string): void {
    sessionStorage.removeItem(key);
  }

  get getActiveLanguage() {
    return this.activelanguage.asObservable();
  }

  setActiveLanguage(lang) {
    sessionStorage.setItem('languageMaster', JSON.stringify(lang));
    this.activelanguage.next(lang);
  }

  broadcast(name: string, ...args) {
    this.subject.next({
      name,
      args
    });
  }

  processLineResp(data) {
    const lineResp = {
      status: 'success',
      data: []
    };
    // if (data._id) {
    //  if (data._id.$oid) {
    if (data.data) {
      for (const line of data.data) {
        const tempLine = {
          name: line.name,
          lineId: line.id,
          localName: line.localName !== null ? line.localName : line.name,
          dfosVersion: line.dfosVersion ? line.dfosVersion : null,
          dfosLineId: line.lineId ? line.lineId : null,
          sapCode: line.sapCode ? line.sapCode : null,
          skuMdUpdateMethod: line.skuMdUpdateMethod ? line.skuMdUpdateMethod : null
        };
        lineResp.data.push(tempLine);
      }
      return lineResp;
    } else {
      return lineResp;
    }
    // } else {
    //   return lineResp;
    // }
    // } else {
    //   return lineResp;
    // }
    //  return lineResp;
  }

  processSkuResp(data) {
    const skuResp = {
      status: 'success',
      data: []
    };
    if (data._id) {
      if (data._id.$oid) {
        if (data.Sku) {
          for (const sku of data.Sku) {
            const tempSku = {
              skucode: sku.name ? sku.name : null,
              id: sku.id ? (sku.id.$oid ? sku.id.$oid : null) : null,
              description: sku.description ? sku.description : null,
              barcode: sku.barCode ? sku.barCode : null,
              type: 'dfos'
            };
            skuResp.data.push(tempSku);
          }
          return skuResp;
        } else {
          return skuResp;
        }
      } else {
        return skuResp;
      }
    } else {
      return skuResp;
    }
  }

  rolePrioritySetter(profile: any) {
    if (!profile) {
      return '';
    }
    return ROLES.filter(item => {
      return profile.toLocaleString().toLowerCase().split(' ').join('-').split(',').includes(item);
    });
  }
}
